// i18n initialization — react-i18next with namespace-per-feature structure.
// Default: English. Planned: Spanish, French.
// Locale preference persisted in localStorage key 'synvya_locale'.

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enCommon from './en/common.json'
import enLoyalty from './en/loyalty.json'
import enPulse from './en/pulse.json'
import enOffers from './en/offers.json'
import enHappyHour from './en/happyHour.json'
import enEvents from './en/events.json'
import enCustomers from './en/customers.json'
import enAbout from './en/about.json'
import enAuth from './en/auth.json'
import enSettings from './en/settings.json'
import enDiscovery from './en/discovery.json'
import enOnboarding from './en/onboarding.json'
import enReservations from './en/reservations.json'
import enTakeout from './en/takeout.json'
import enBilling from './en/billing.json'
import esCommon from './es/common.json'
import frCommon from './fr/common.json'

const LOCALE_KEY = 'synvya_locale'

function storedLocale(): string {
  try {
    return localStorage.getItem(LOCALE_KEY) ?? 'en'
  } catch {
    return 'en'
  }
}

i18n.use(initReactI18next).init({
  lng: storedLocale(),
  fallbackLng: 'en',
  defaultNS: 'common',
  ns: ['common', 'loyalty', 'pulse', 'offers', 'happyHour', 'events', 'customers', 'about', 'auth', 'settings', 'discovery', 'onboarding', 'reservations', 'takeout', 'billing'],
  resources: {
    en: {
      common: enCommon,
      loyalty: enLoyalty,
      pulse: enPulse,
      offers: enOffers,
      happyHour: enHappyHour,
      events: enEvents,
      customers: enCustomers,
      about: enAbout,
      auth: enAuth,
      settings: enSettings,
      discovery: enDiscovery,
      onboarding: enOnboarding,
      reservations: enReservations,
      takeout: enTakeout,
      billing: enBilling,
    },
    es: { common: esCommon },
    fr: { common: frCommon },
  },
  interpolation: {
    escapeValue: false, // React already escapes
  },
})

// Persist language changes
i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem(LOCALE_KEY, lng)
  } catch {
    // localStorage unavailable — skip
  }
})

export default i18n
